import { Pipe, PipeTransform } from "@angular/core";
import { OrgBranchStateManagement } from './../store/branch/reducer';
@Pipe({
    name: 'branchFilter'
})

export class BranchFilterPipe implements PipeTransform{
    constructor(
        private branchStore: OrgBranchStateManagement
         ){

    }
      transform(obj:any,arg1:string) {
          let branches = this.branchStore.get();
        //   console.log('branches',branches)
          if(branches!= undefined && branches.length>0){
            let filterd = branches.filter(id=> id.branchID==obj);
            if(filterd && filterd[0] && filterd[0][arg1]) return filterd[0][arg1];
            else return '---';
          }
      }
}